import styled from 'styled-components';
import COLORS from '../../../../../constants/COLORS';
import COLORS_MARKETPLACE from '../../../../../constants/COLORS_MARKETPLACE';
import mixins from '../../../../../styles/mixins';
import { lighten } from 'polished';

export default {
  Counter: styled.div`
    display: flex;
    align-items: center;
  `,
  Btn: styled.button`
    ${mixins.btnReset};

    display: flex;
    justify-content: center;
    align-items: center;

    width: 36px;
    height: 36px;

    font-size: 28px;
    color: ${COLORS.WHITE};

    border-radius: 50%;

    background-color: ${({ theme }) => theme.buttonBackground || COLORS_MARKETPLACE.SECONDARY};
    transition: 0.1s ease-in;

    &:hover,
    &:focus-visible {
      &:not(:disabled) {
        background-color: ${({ theme }) =>
          lighten(0.1, theme.buttonBackground) || COLORS_MARKETPLACE.PRIMARY};
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  `,
  Value: styled.span`
    ${mixins.h3}

    padding: 0 8px;
  `,
};
